/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import CustomModal from "../../components/Modal/CustomModal";
import CustomListContainer from "../../components/CustomListContainer";
import CustomListItem from "../../components/CustomListItem";
import ButtonIcon from "../../components/buttons/ButtonIcon";
import DownloadIcon from "@mui/icons-material/Download";
import {FILE_TYPE} from "../../Helpers/fileType";
import {ListItemText} from "@mui/material";
import CustomDescriptionModal from "../../components/CustomDescriptionModal";
import ImportFileApp from "./Functionality/ImportFileApp";
import {ACTION_MODEL} from '../../Helpers/ActionModel';
import CustomPhotoPicker from '../../components/PhotoPicker/CustomPhotoPicker';

const ImportFileModal = (props) => {
    const {title_modal, element_modal, onHide} = props;
    const { t, dispatch, emptyFields, handleUploadFile, DownloadForm,
        photoPickerFile,
        setPhotoPickerFile
    } = ImportFileApp(props);

    return (
        <CustomModal
            {...props}
            title={title_modal}
            size="lg"
            buttonConfirm="confirm"
            cancelButton={true}
            confirmButton={true}
            onConfirm={handleUploadFile}
            onHide={onHide}
        >
            <div className={"row"}>
                <div className={"col-12"}>
                    <CustomDescriptionModal>
                        {t('to_upload_multiple')}
                        <span className={"bold-text"}>{" " + t(element_modal) + " "}</span>
                        {t('you_need_to_follow_the_next_steps')}
                    </CustomDescriptionModal>
                </div>

                <div className={"col-12 pl-5"}>
                    <CustomListContainer styleType={"disc"}>
                        <CustomListItem key={1} display={'list-item'}>
                            <div className={"d-inline-flex"}>
                                <ListItemText primary={t('click_to_download_file')} />
                                <ButtonIcon
                                    id='btn_ifm_download'
                                    Icon={DownloadIcon}
                                    onClick={() => {
                                        dispatch(DownloadForm());
                                    }}
                                    title={''}
                                    className='btn-background-transparent ml-2'
                                    iconProps={'btn-icon-svg-black btn-icon-svg-12px'}
                                />
                            </div>
                        </CustomListItem>
                        <CustomListItem key={2} display={'list-item'} text={t('fill_on_it_the_data_and_make_sure_you_are_following_the_correct_way_to_fill_it')}/>
                        <CustomListItem key={3} display={'list-item'} text={t('drag_&_drop_the_file_or_click_on_the_shape_to_search_on_the_explorer')}/>
                        <CustomListItem key={4} display={'list-item'} text={t('click_on_the_create_button_to_confirm_the_action')}/>
                        <CustomListItem key={5} display={'list-item'} text={t('in_case_the_server_finds_some_errors_they_will_appear_to_be_corrected_then_follow_the_steps_again')}/>
                    </CustomListContainer>
                </div>
                <div className={"col-12"}>
                    <CustomPhotoPicker
                        id='fp_aei_create_photo_file'
                        photoPicker={photoPickerFile}
                        setPhotoPicker={setPhotoPickerFile}
                        actionModel={ACTION_MODEL.CREATE}
                        accept={{ ...FILE_TYPE.XLSX }}
                        required={true}
                        classWith={'w-100'}
                        showPreview={false}
                        emptyFields={emptyFields}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default ImportFileModal;
